/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { Epic, ofType } from 'redux-observable';
import { catchError, exhaustMap, filter, map } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { AxiosError } from 'axios';
import { parseError } from '../../utils/utils';
import { i18n } from '../translation/i18n';
import { RootState } from '../store.typings';
import {
    fetchStoresSuccessAction,
    fetchStoresErrorAction,
    StoresMapActionType,
    StoresMapAction,
} from '../actions/AStoresMap';
import { storesClient } from '../api/stores/storesClient';
import { StoresMapFilterParams } from '../api/stores/storesClientTypings';
import { setZoomLevel } from '../../components/Map/utils';

type EStoreMap = Epic<StoresMapAction, StoresMapAction, RootState>;

export const fetchMapStoresEpic: EStoreMap = (action$, state) => {
    return action$.pipe(
        ofType(
            StoresMapActionType.OPEN_STORES_MAP_PAGE,
            StoresMapActionType.APPLY_FILTERS,
            StoresMapActionType.VIEWPORT_CHANGE,
        ),
        filter((action) => {
            const filterParams = state.value.storeMapReducer.filterParams;

            return (
                checkIsNotFilters(filterParams) ||
                (!checkIsNotFilters(filterParams) &&
                    (action.type === StoresMapActionType.OPEN_STORES_MAP_PAGE ||
                        action.type === StoresMapActionType.APPLY_FILTERS))
            );
        }),
        exhaustMap(() => {
            const { viewport, filterParams } = state.value.storeMapReducer;
            const zoom = setZoomLevel(viewport.zoom);

            const params = {
                filterParams,
                viewport: {
                    ...viewport,
                    zoom,
                },
            };

            if (!checkIsNotFilters(filterParams)) {
                delete params.viewport.bounds;
                delete params.viewport.zoom;
            }

            return from(storesClient.getStoresForMap(params)).pipe(
                map((stores) => fetchStoresSuccessAction(stores)),

                catchError((err: AxiosError) =>
                    of(fetchStoresErrorAction(parseError(err, i18n.t('RegistryScreens.errors.storesListNotFound')))),
                ),
            );
        }),
    );
};

const checkIsNotFilters = (filters: StoresMapFilterParams): boolean => {
    return filters.search_text === '' && filters.storeTypes === null && filters.city === null;
};
